import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { GetProposalProjectList } from "../Responses/GetProposalProjectList";

export async function getProposalProjectList(data) {
	let response = await getAPIResponse("/v1/proposal-project-list", data);
	if (response === null) {
		return null;
	}
	let getProposalProjectList = GetProposalProjectList.createFromResponseData(response);
	return getProposalProjectList;
}